import { useHTTP, useHTTPQuery } from "@/lib/http";
import type { EmblemRollsModel } from "@/features/emblems/api/models/EmblemRollsModel";

export const useEmblemRolls = () => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["userEmblemRolls"],
		queryFn: () => http<EmblemRollsModel>({
			method: "GET",
			url: "/emblem/rolls"
		})
	});
};
